export default "__VITE_ASSET__BY3RBvcc__"